import api from "./api";

export const getRecommendationArticles = async () => {
    try {
        const response = await api.get(`/recommendation-articles?populate=*`);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getSingleRecommendationArticle = async (id) => {
    try {
        const response = await api.get(`/recommendation-articles/${id}`, {
            params: {
                populate: {
                    coverImage: true,
                    gallery: true,
                    locations: {
                        populate: {
                          establishment: {
                            populate: ['images']
                          },
                          event: {
                            populate: ['images']
                          }
                        }
                    }
                }
            }
        });
        return (response.data.data);
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const countRecommendationArticles = async () => {
    try {
        const response = await getRecommendationArticles();
        const length = response.length;
        return length;
    } catch (e) {
        console.error(e);
    }
};

export const getFilteredRecommendationArticles = async (filters = {}, page = 1, pageSize = 12) => {
    try {
        const queryParams = {
            populate: '*',
            filters: {},
            pagination: {
                page,
                pageSize
            }
        };

        // Add search term if provided
        if (filters.search) {
            queryParams.filters.$or = [
                {
                    title: {
                        $containsi: filters.search
                    }
                },
                {
                    description: {
                        $containsi: filters.search
                    }
                }
            ];
        }

        // Add sorting if provided
        if (filters.sort) {
            queryParams.sort = [filters.sort];
        }

        const response = await api.get('/recommendation-articles', { params: queryParams });
        return {
            data: response.data.data,
            pagination: response.data.meta.pagination
        };
    } catch (e) {
        console.error(e);
        return {
            data: [],
            pagination: {
                page: 1,
                pageSize: pageSize,
                pageCount: 0,
                total: 0
            }
        };
    }
};

export const deleteRecommendationArticle = async (id) => {
    try {
        const response = await api.delete(`/recommendation-articles/${id}`);
        return true;
    } catch (err) {
        console.error('Error deleting recommendation article:', err);
        return false;
    }
};

export const createRecommendationArticle = async (articleData) => {
    try {
        const response = await api.post('/recommendation-articles', {
            data: articleData
        });
        return response.data.data;
    } catch (err) {
        console.error('Error creating recommendation article:', err);
        throw err;
    }
};

export const updateRecommendationArticle = async (id, articleData) => {
    try {
        const response = await api.put(`/recommendation-articles/${id}`, {
            data: articleData
        });
        return response.data.data;
    } catch (err) {
        console.error('Error updating recommendation article:', err);
        throw err;
    }
};

export const addLocationToArticle = async (articleId, locationData) => {
    try {
        const currentArticle = await getSingleRecommendationArticle(articleId);
        const currentLocations = currentArticle.locations || [];
        
        // Add the new location
        const updatedLocations = [...currentLocations, locationData];
        
        // Update the article with the new locations array
        return await updateRecommendationArticle(articleId, { 
            locations: updatedLocations 
        });
    } catch (err) {
        console.error('Error adding location to article:', err);
        throw err;
    }
};

export const removeLocationFromArticle = async (articleId, locationIndex) => {
    try {
        const currentArticle = await getSingleRecommendationArticle(articleId);
        const currentLocations = [...(currentArticle.locations || [])];
        
        // Remove the location at the specified index
        currentLocations.splice(locationIndex, 1);
        
        // Update the article with the modified locations array
        return await updateRecommendationArticle(articleId, { 
            locations: currentLocations 
        });
    } catch (err) {
        console.error('Error removing location from article:', err);
        throw err;
    }
};

export const updateArticleLocation = async (articleId, locationIndex, locationData) => {
    try {
        const currentArticle = await getSingleRecommendationArticle(articleId);
        const currentLocations = [...(currentArticle.locations || [])];
        
        // Update the location at the specified index
        currentLocations[locationIndex] = {
            ...currentLocations[locationIndex],
            ...locationData
        };
        
        // Update the article with the modified locations array
        return await updateRecommendationArticle(articleId, { 
            locations: currentLocations 
        });
    } catch (err) {
        console.error('Error updating article location:', err);
        throw err;
    }
};

export const getDifficultyOptions = () => {
    return [
        { value: 'Facile', label: 'Facile' },
        { value: 'Moyen', label: 'Moyen' },
        { value: 'Difficile', label: 'Difficile' }
    ];
};